import { User } from 'src/backoffice-app-code/features/Auth/models/User';
import {
  HomePagesRoutes,
  PartnerUsersRoutes,
  SpecificationRootes,
  RetailerTransactionsRootes,
  RetailersRoutes,
} from '../Routes';
import { ICONS } from './navIcons';

export const getRetailerPartnerAdminNavConfig = (user: User | undefined) => {
  if (!user) return [];
  const retailerPartnerAdminNavConfig = [
    {
      subheader: 'general',
      items: [{ title: 'Home', path: HomePagesRoutes.retailerHomePage, icon: ICONS.dashboard }],
    },
    {
      subheader: 'Transakcije',
      items: [
        {
          title: 'Transakcije',
          path: RetailerTransactionsRootes.index,
          icon: ICONS.invoice,
        },
        {
          title: 'Specifikacije',
          path: SpecificationRootes.index,
          icon: ICONS.banking,
        },
      ],
    },
    {
      subheader: 'Managment',
      items: [
        {
          title: 'Administratori',
          path: PartnerUsersRoutes.buildIndex(user.partnerId),
          icon: ICONS.user,
        },
        {
          title: 'Pos useri',
          path: RetailersRoutes.posUserIndex,
          icon: ICONS.file,
        },
      ],
    },
  ];

  return retailerPartnerAdminNavConfig;
};
